import React from 'react';
import RotationAnimationWrapper from "../Wrappers/RotationAnimationWrapper";

const SplashScreenRings = () => {
    return (
        <RotationAnimationWrapper duration={20}>
        <svg width="291" height="289" viewBox="0 0 291 289" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4"
                  d="M283.99 147.697L283.983 147.737V147.779C283.983 225.248 224.535 283.5 147.492 283.5C108.922 283.5 75.805 273.144 51.1487 251.028C26.4978 228.918 10.244 195 5.5 147.754C5.51398 70.3002 70.4518 7.5 147.492 7.5C186.019 7.5 223.392 23.1473 249.507 48.5036C275.617 73.8546 290.459 108.891 283.99 147.697Z"
                  stroke="white"/>
            <path opacity="0.4"
                  d="M2.06387 147.779L2.07068 147.82V147.861C2.07068 228.137 63.6425 288.5 143.438 288.5C183.383 288.5 217.683 277.769 243.221 254.852C268.753 231.939 285.587 196.791 290.5 147.836C290.486 67.5754 223.229 2.5 143.438 2.5C103.535 2.5 64.8275 18.714 37.7793 44.9889C10.7365 71.2585 -4.63596 107.565 2.06387 147.779Z"
                  stroke="white"/>
            <path
                d="M2.06387 147.779L2.07068 147.82V147.861C2.07068 228.137 63.6425 288.5 143.438 288.5C183.383 288.5 217.683 277.769 243.221 254.852C268.753 231.939 285.587 196.791 290.5 147.836C290.486 67.5754 223.229 2.5 143.438 2.5C103.535 2.5 64.8275 18.714 37.7793 44.9889C10.7365 71.2585 -4.63596 107.565 2.06387 147.779Z"
                stroke="white"/>
            <defs>
                <radialGradient id="paint0_radial_197_314" cx="0" cy="0" r="1"
                                gradientUnits="userSpaceOnUse"
                                gradientTransform="translate(143 140) rotate(90) scale(171.5)">
                    <stop stopOpacity="0"/>
                    <stop offset="1"/>
                </radialGradient>
            </defs>

            <g filter="url(#filter0_bi_1307_2549)">
                <circle cx="144" cy="140" r="140" fill="black" fillOpacity="0.1"/>
                <circle cx="144" cy="140" r="140" stroke="url(#paint0_linear_1307_2549)"
                        strokeOpacity="0.28"
                        strokeWidth="1.5"/>
            </g>
            <defs>
                <filter id="filter0_bi_1307_2549" x="-12" y="-11.123" width="329" height="329"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="6"/>
                    <feComposite in2="SourceAlpha" operator="in"
                                 result="effect1_backgroundBlur_1307_2549"/>
                    <feBlend mode="normal" in="SourceGraphic"
                             in2="effect1_backgroundBlur_1307_2549"
                             result="shape"/>
                    <feColorMatrix in="SourceAlpha" type="matrix"
                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="17.5"/>
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix type="matrix"
                                   values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"/>
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1307_2549"/>
                </filter>
                <linearGradient id="paint0_linear_1307_2549" x1="68.8429" y1="25.5461"
                                x2="196.594"
                                y2="284.089"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="white"/>
                    <stop offset="1" stopColor="white" stopOpacity="0"/>
                </linearGradient>
            </defs>
        </svg>
        </RotationAnimationWrapper>
    );
};

export default SplashScreenRings;
